import React, { useEffect, useState } from 'react';
import { ArrowBackIos } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useGetUserPendingActivationMutation } from '../../services/users/usersService';
import { Header } from '../../components/header/header';
import {
  StyledHeaderContainer,
  StyledTitleHeader
} from '../../components/layout/main/mainStyles';
import { ButtonIconStyled } from '../devices/devicesStyles';
import Strings from '../../i18n';
import { ReOpenSideBarIcon } from '../../components/commons/reOpenSideBarIcon/reOpenSideBarIcon';
import { UsersActivationTemplate } from '../../templates/usersActivationTemplate/usersActivationTemplate';
import { RightSideBar } from '../../components/layout/rightSideBar/rightSideBar';
import { ActivateUserSidebar } from '../../templates/usersActivationTemplate/activateUserSidebar/activateUserSidebar';
import { viewRightSideBarEnum } from '../../constants/sidebarEnums';
import { ActivateMultipleUsersSidebar } from '../../templates/usersActivationTemplate/activateMultipleUsersSidebar/activateMultipleUsersSidebar';
import { IUserPendingActivation } from '../../types/users';

export const UserActivationView = () => {
  const navigate = useNavigate();
  const [openSideBarFor, setOpenSideBarFor] = useState<number | null>(null);
  const [getUserPendingActivation, { isSuccess, data, isLoading }] =
    useGetUserPendingActivationMutation();
  const [openSideBar, setOpenSideBar] = useState<boolean>(false);
  const [selectedItems, setSelectedItems] = useState<IUserPendingActivation[]>(
    []
  );

  const reloadTable = () => {
    getUserPendingActivation();
    setSelectedItems([]);
  };

  const switchComponentToShowRightSideBar = () => {
    switch (openSideBarFor) {
      case viewRightSideBarEnum.singleUserActivation:
        return (
          <ActivateUserSidebar
            setOpenRightSideBar={setOpenSideBar}
            selectedItem={selectedItems[0]}
            reloadTable={reloadTable}
          />
        );
      case viewRightSideBarEnum.multipleUserActivation:
        return (
          <ActivateMultipleUsersSidebar
            selectedItems={selectedItems}
            setOpenRightSideBar={setOpenSideBar}
            reloadTable={reloadTable}
          />
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    reloadTable();
  }, []);

  useEffect(() => {
    if (selectedItems.length === 1) {
      setOpenSideBar(true);
      setOpenSideBarFor(viewRightSideBarEnum.singleUserActivation);
    } else if (selectedItems.length > 1) {
      setOpenSideBar(true);
      setOpenSideBarFor(viewRightSideBarEnum.multipleUserActivation);
    } else {
      setOpenSideBar(false);
    }
  }, [selectedItems]);

  return (
    <>
      <Header>
        <StyledHeaderContainer>
          <div className="row justify-content-between">
            <div className="col-4 text-left">
              <ButtonIconStyled size="small" onClick={() => navigate(-1)}>
                <ArrowBackIos />
              </ButtonIconStyled>
            </div>
            <div className="col-4 text-center">
              <StyledTitleHeader>
                {Strings.users.newAccountCodes}
              </StyledTitleHeader>
            </div>
            <div className="col-4 text-right">
              <ReOpenSideBarIcon
                isOpenRightSideBar={openSideBar}
                selectedItems={selectedItems}
                singleItemMethod={() => {
                  setOpenSideBar(true);
                }}
                multipleItemsMethod={() => {
                  setOpenSideBar(false);
                }}
              />
            </div>
          </div>
        </StyledHeaderContainer>
      </Header>
      <UsersActivationTemplate
        isLoading={isLoading}
        isSuccess={isSuccess}
        allUsers={data ?? []}
        openedSideBar={openSideBar}
        setOpenSideBar={setOpenSideBar}
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
      />
      <RightSideBar
        open={openSideBar}
        onMenuClose={() => {
          setOpenSideBar(false);
        }}
      >
        {switchComponentToShowRightSideBar()}
      </RightSideBar>
    </>
  );
};
